import React from 'react';
import { Box, IconButton, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';

const MainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  position: 'relative'
}));

interface ContentContainerProps {
  isMobile: boolean;
}

const ContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<ContentContainerProps>(({ theme, isMobile }) => ({
  flexGrow: 1,
  width: '100%',
  padding: isMobile ? theme.spacing(2) : theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(2),
  left: theme.spacing(2),
  zIndex: 1100,
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
}));

interface QuestionLayoutProps {
  children: React.ReactNode;
}

export const QuestionLayout: React.FC<QuestionLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const { isMobile } = useResponsiveLayout();

  const handleClose = () => {
    navigate('/home');
  };

  return (
    <MainContainer>
      <CloseButton onClick={handleClose} aria-label="close">
        <CloseIcon />
      </CloseButton>
      <ContentContainer isMobile={isMobile}>
        {children}
      </ContentContainer>
    </MainContainer>
  );
};
